import React from 'react';
import { TrophyIcon, UsersIcon, CalendarIcon, BadgeCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    icon: TrophyIcon,
    value: 'Nr. 1',
    label: 'unabhängige Handwerkerplattform'
  }, {
    icon: UsersIcon,
    value: "150'000+",
    label: 'glückliche Kunden'
  }, {
    icon: CalendarIcon,
    value: '15 Jahre+',
    label: 'Erfahrung'
  }, {
    icon: BadgeCheckIcon,
    value: '200+',
    label: 'geprüfte Malerfirmen'
  }];
  return <section className="py-12 sm:py-16 bg-white border-t border-gray-100" data-id="element-50">
      <div className="max-w-6xl mx-auto px-4" data-id="element-51">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12" data-id="element-52">
          {stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="text-center" data-id="element-53">
              <s.icon className="w-9 h-9 text-ofri-blue mx-auto mb-3" data-id="element-54" />
              <div className="text-2xl font-bold text-gray-900 mb-1" data-id="element-55">
                {s.value}
              </div>
              <div className="text-sm text-gray-600" data-id="element-56">{s.label}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}